import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';
import { FScoreMetric } from 'app/model/redshift/f-score-metric';
import { fScoreReportService } from 'app/services/seam-request/f-score-report.service';
import { FScoreReportGrid } from 'features/qa/f-score/f-score-report-grid';

export const FScoreReport: React.FunctionComponent = () => {
    const [currentStores, setCurrentStores] = useState<FScoreMetric[]>([]);

    useEffect(() => {
        const inflightStoreList = fScoreReportService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_ENORMOUS,
            })
            .subscribe(setCurrentStores);

        return () => {
            inflightStoreList.unsubscribe();
        };
    }, []);

    return (
        <>
            <Typography variant='h5'>F-Score Report</Typography>
            <FScoreReportGrid
                density='compact'
                rows={currentStores}
                pagination
                autoPageSize
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                }}
            />
        </>
    );
};
